<eff-expansion-panel
    [contentTemplate]="content"
    [title]="'effSourceDocumentInfoBox.panelTitle' | t"
    class="eff-details-panel"
    [panelOpenState]="panelOpenState"
    data-uiid="new-eff-upload-source-document-source-upload-instructions-info-box"
>
    <ng-template #content>
        <div class="rows-container">
            <div
                class="regular-text multiple-whitespaces"
                [innerHTML]="effectivenessModel.sourceDocumentUploadInstructions"
            ></div>
            @if (
                stepPermissions?.canViewSourceDocuments && !effectivenessModel.useControlExecution
            ) {
                <div class="source-documents-list">
                    @if (sourceDocumentModel && sourceDocumentModel.documents?.length > 0) {
                        <documents-list
                            [canAdd]="false"
                            [canEdit]="false"
                            [canDelete]="false"
                            [documents]="sourceDocumentModel.documents"
                        ></documents-list>
                    } @else {
                        <div class="header no-documents">{{ 'effSourceDocumentInfoBox.noSourceDocuments' | t }}</div>
                    }
                </div>
            }
            @if (isNonOccurrenceTestPlan && effectivenessModel.useControlExecution) {
                <div class="header no-documents">
                    {{ 'effSourceDocumentInfoBox.noControlExecutions' | t }}</div>
            }

            @if (!isNonOccurrenceTestPlan) {
                <div class="rows-container">
                    @if (
                        stepPermissions?.canViewSourceDocuments &&
                        effectivenessModel.useControlExecution
                    ) {
                        <div class="row-container popup-hover" (click)="openPopup()">
                            <div class="view-sources-text">{{ 'effSourceDocumentInfoBox.viewTasks' | t }}</div>
                            <eff-icon
                                icon="north_east_outlined"
                                size="sixteen-size ocean-blue lh-24"
                            >
                            </eff-icon>
                        </div>
                    }
                    <div class="bold-text header">{{ 'effSourceDocumentInfoBox.sampling' | t }}</div>
                    @if (effectivenessModel.samplePopulation) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.population' | t }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.samplePopulation }}
                            </div>
                        </div>
                    }
                    @if (effectivenessModel.numberOfTestSamples) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.sampleSize' | t }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.numberOfTestSamples }}
                            </div>
                        </div>
                    }
                    @if (effectivenessModel.sampleTypeDescription) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.sampleType' | t }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.sampleTypeDescription }}
                            </div>
                        </div>
                    }

                    @if (isSpreadSheet()) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.columnId' | t }}</div>
                            <div class="regular-text">{{ columnId }}</div>
                        </div>

                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.rowsToSkip' | t }}</div>
                            <div class="regular-text">{{ rowsToSkip }}</div>
                        </div>
                    }

                    @if (
                        effectivenessModel.sampleGenerationType == sampleGenerationType.automatic &&
                        effectivenessModel.seedNumber
                    ) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.seedNumber' | t }}</div>
                            <div class="regular-text">{{ effectivenessModel.seedNumber }}</div>
                        </div>
                    }

                    @if (effectivenessModel.sampleGenerationType == sampleGenerationType.manual) {
                        <div class="bold-text row-label">{{ 'effSourceDocumentInfoBox.reasonManualSampling' | t }}</div>
                        <div class="regular-text">
                            {{ effectivenessModel.sampleGenerationReason }}
                        </div>
                    }
                    @if (effectivenessModel.useControlExecution) {
                        <div
                            class="row-container download-sampled-population"
                            data-uiid="new-eff-upload-source-document-source-upload-instructions-info-box-download-sampled-population-button"
                            (click)="downloadSampledPopulation()"
                        >
                            <eff-icon
                                class="action-icon"
                                icon="cloud_download_outlined"
                                [size]="''"
                            ></eff-icon>
                            <div class="download-sampled-population-text">
                                {{ 'effSourceDocumentInfoBox.downloadSampledPopulation' | t }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </ng-template>
</eff-expansion-panel>
